export default "__VITE_ASSET__DkFcqTh3__"